import { apiClient } from '@/core/http'
import { getPayloadEnrichments } from '@/utils/payload-enricher'
import { createDebugLogger, getFilePathFromUrl } from '@/utils/logger'
import { getWidgetId } from '@/utils/widget-id'

import type { SendMessageRequest } from '@/features/conversation/types/send-message-request'
import type { SendMessageResponse } from '@/features/conversation/types/send-message-response'

import type { WidgetConfig } from '@/config/types/widget-config'

const logger = createDebugLogger(getFilePathFromUrl(import.meta.url))

const SEND_TIMEOUT_MS = 30_000

export async function sendMessage(data: SendMessageRequest, widgetConfig: WidgetConfig): Promise<SendMessageResponse> {
  const enrichments = getPayloadEnrichments(widgetConfig)
  const payload = {
    ...data,
    ...enrichments,
  }

  logger.debug('sendMessage', 'Sending message with payload', payload)

  const widgetId = getWidgetId()
  if (!widgetId) {
    throw new Error('Widget ID is required to send message')
  }

  // a send that hangs is reported as failed, so the visitor gets "Send again" instead of a message stuck pending
  const response = await apiClient.post<SendMessageResponse>(`/v1/widget/${widgetId}/send-message`, payload, {
    timeout: SEND_TIMEOUT_MS,
  })

  logger.debug('sendMessage', 'Message sent successfully', {
    messageId: response.data.message_id,
    conversationId: response.data.conversation_id,
  })
  return response.data
}
